import { EPipelineSegment } from '@progress-fe/core';
export const PipeLineSegmentIcon = {
    [EPipelineSegment.Pipe]: 'Pipeline_Pipe',
    [EPipelineSegment.CouplingUnion]: 'Pipeline_CouplingUnion',
    [EPipelineSegment.SwageAbrupt]: 'Pipeline_Swage',
    [EPipelineSegment.Swage45Degree]: 'Pipeline_Swage',
    [EPipelineSegment.TeeElbow]: 'Pipeline_Tee',
    [EPipelineSegment.TeeBranchBlanked]: 'Pipeline_Tee',
    [EPipelineSegment.Bend90_RD1]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD1_5]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD2]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD3]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD4]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD6]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD8]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD10]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD12]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD14]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD16]: 'Pipeline_Bend',
    [EPipelineSegment.Bend90_RD20]: 'Pipeline_Bend',
    [EPipelineSegment.Elbow45Long]: 'Pipeline_Elbow',
    [EPipelineSegment.Elbow45Mitre]: 'Pipeline_Elbow',
    [EPipelineSegment.Elbow45Std]: 'Pipeline_Elbow',
    [EPipelineSegment.Elbow90Long]: 'Pipeline_Elbow',
    [EPipelineSegment.Elbow90Mitre]: 'Pipeline_Elbow',
    [EPipelineSegment.Elbow90Std]: 'Pipeline_Elbow',
    [EPipelineSegment.Degree180CloseReturn]: 'Pipeline_Return180',
    [EPipelineSegment.AngleValve45Open]: 'Pipeline_AngleValve',
    [EPipelineSegment.AngleValve90Open]: 'Pipeline_AngleValve',
    [EPipelineSegment.AngleValveOpen]: 'Pipeline_AngleValve',
    [EPipelineSegment.BallValveOpen]: 'Pipeline_BallValve',
    [EPipelineSegment.ButterflyValve2_8InOpen]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValve10_14InOpen]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValve16_24InOpen]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValveAngle5]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValveAngle10]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValveAngle20]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValveAngle40]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.ButterflyValveAngle60]: 'Pipeline_ButterflyValve',
    [EPipelineSegment.CheckValveBall]: 'Pipeline_CheckValve',
    [EPipelineSegment.CheckValveDisk]: 'Pipeline_CheckValve',
    [EPipelineSegment.CheckValveLift]: 'Pipeline_CheckValve',
    [EPipelineSegment.CheckValve45Lift]: 'Pipeline_CheckValve',
    [EPipelineSegment.CheckValveSwing]: 'Pipeline_CheckValve',
    [EPipelineSegment.GateValveCraneOpen]: 'Pipeline_GateValve',
    [EPipelineSegment.GateValveOneQuarter]: 'Pipeline_GateValve',
    [EPipelineSegment.GateValveHalf]: 'Pipeline_GateValve',
    [EPipelineSegment.GateValveThreeQuarter]: 'Pipeline_GateValve',
    [EPipelineSegment.GateValveOpen]: 'Pipeline_GateValve',
    [EPipelineSegment.GlobeValveCraneOpen]: 'Pipeline_GlobeValve',
    [EPipelineSegment.GlobeValveHalf]: 'Pipeline_GlobeValve',
    [EPipelineSegment.GlobeValveOpen]: 'Pipeline_GlobeValve',
    [EPipelineSegment.PlugCockAngle5]: 'Pipeline_PlugCock',
    [EPipelineSegment.PlugCockAngle10]: 'Pipeline_PlugCock',
    [EPipelineSegment.PlugCockAngle20]: 'Pipeline_PlugCock',
    [EPipelineSegment.PlugCockAngle40]: 'Pipeline_PlugCock',
    [EPipelineSegment.PlugCockAngle60]: 'Pipeline_PlugCock',
    [EPipelineSegment.PlugCockOpen]: 'Pipeline_PlugCock',
    [EPipelineSegment.BlowoffValveOpen]: 'Pipeline_BlowoffValve',
    [EPipelineSegment.DiaphragmValveOneQuarter]: 'Pipeline_DiaphragmValve',
    [EPipelineSegment.DiaphragmValveHalf]: 'Pipeline_DiaphragmValve',
    [EPipelineSegment.DiaphragmValveThreeQuarter]: 'Pipeline_DiaphragmValve',
    [EPipelineSegment.DiaphragmValveOpen]: 'Pipeline_DiaphragmValve',
    [EPipelineSegment.FootValve]: 'Pipeline_FootValve',
    [EPipelineSegment.FootValveHingedDisk]: 'Pipeline_FootValve',
    [EPipelineSegment.FootValvePoppetDisk]: 'Pipeline_FootValve',
    [EPipelineSegment.WaterMeterDisk]: 'Pipeline_WaterMeter',
    [EPipelineSegment.WaterMeterPiston]: 'Pipeline_WaterMeter',
    [EPipelineSegment.WaterMeterRotary]: 'Pipeline_WaterMeter',
    [EPipelineSegment.WaterMeterTurbine]: 'Pipeline_WaterMeter'
};
//# sourceMappingURL=icon.constant.js.map